
import { defineComponent, ref, PropType, computed } from 'vue';
import OverlayModal from '@/components/Calendar/OverlayModal.vue';
import CheckBoxInput from '@/components/CheckBoxInput.vue';
import { IdName } from '@/models/Interfaces';

export default defineComponent({
    props: {
        tags: {
            type: Array as PropType<IdName[]>,
            required: true
        },
    },
    components: { OverlayModal, CheckBoxInput },
    name: 'AddTagsModal',
    async setup(props, { emit }) {
        const isOpen = ref(false);
        const searchTagName = ref('');
        const selectedTagIds = ref<string[]>([]);;
        const filteredTags = computed(() => {
            if (searchTagName.value) {
                return props.tags.filter(t => t.name.toLocaleLowerCase().includes(searchTagName.value.toLocaleLowerCase()));
            }
            return JSON.parse(JSON.stringify(props.tags));
        });
        const selectedTags = ref<IdName[]>([]);
        function open(selectedOrderTagIdsProps: string[]) {
            selectedTagIds.value = selectedOrderTagIdsProps;
            searchTagName.value = '';
            isOpen.value = true;
        }
        function close() {
            isOpen.value = false;
        }
        function onSave() {
            emit('onSave', selectedTagIds.value);
        }
        return { open, close, onSave, isOpen, searchTagName, filteredTags, selectedTags, selectedTagIds };
    }
});
